import React, {
  useEffect,
  useCallback,
  useState,
  useRef,
  ChangeEvent,
} from 'react';
import { Tabs, TabList, TabPanels, Tab, TabPanel, Flex, Text, List, ListItem, Table, Thead, Tbody, Tr, Th, Td } from '@chakra-ui/react';
import { FiCamera, FiX, FiTrash2 } from 'react-icons/fi';
import { FaEdit } from 'react-icons/fa';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import Resizer from 'react-image-file-resizer';
import * as Yup from 'yup';
import { LoadScript, GoogleMap, Marker, StandaloneSearchBox } from '@react-google-maps/api';
import { FiSearch, FiLogIn } from 'react-icons/fi';
import { search } from 'ss-search';

import api from '../../services/api';
import { useAuth } from '../../hooks/auth';
import { useToast } from '../../hooks/toast';
import { formatPrice } from '../../utils/format';
import { AppError } from '../../utils/AppError';
import getValidationErrors from '../../utils/getValidationErrors';
import Sidebar from '../../components/Sidebar';
import Loading from '../../components/Loading';
import Input from '../../components/Inputs/Input';
import InputTextArea from '../../components/Inputs/inputTextArea';
import InputSelect from '../../components/Inputs/Selects/InputSelect';
import EndEditMap from '../../components/ComponentsPerfil/EndEditMap';
import ModalPerfilNumero from '../../components/ComponentsPerfil/ModalPerfilNumero';
import ModalPerfilAcesso from '../../components/ComponentsPerfil/ModalPerfilAcesso';
import ModalPerfilEndConfirm from '../../components/ComponentsPerfil/ModalPerfilEndConfirm';
import ModalPerfilDeleteAcesso from '../../components/ComponentsPerfil/ModalPerfilDeleteAcesso';

import {
  Container,
  Content,
  TabsView,
  TabLoja,
  ImgInput,
  FormView,
  TabEndereco,
  MapView,
  GestaoAcessos,
  GestaoAcessosContent,
  GestaoAcessoForm,
} from './styles';

type LojaData = {
  fantazia: string;
  nome: string;
  cnpj: string;
  categoria: string;
  descricao: string;
  ped_min: number;
  url_avatar: string;
  url_page: string;
  fone: string;
  endereco: {
    cep: string;
    uf: string;
    cid: string;
    cidcod: string;
    bai: string;
    endereco: string;
    num: string;
    comp: string;
    formatted_address: string;
    location: {
      lat: number;
      lng: number;
    };
  };
}
type AcessoData = {
  id: number;
  email: string;
  nome: string;
  role: string;
  status: string;
}

const Perfil: React.FC = () => {
  const formRef = useRef<FormHandles>(null);
  const formMapRef = useRef<FormHandles>(null);
  const formGestaoAcessoRef = useRef<FormHandles>(null);
	const searchBoxRef = useRef<any>(null);

  const { company, permissions } = useAuth();
  const { addToast } = useToast();
  const [loading, setLoading] = useState(false);
  const [loadingContent, setLoadingContent] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);

  // Tab LOJA
  const [loja, setLoja] = useState<LojaData>({} as LojaData);
  const [categorias, setCategorias] = useState<any[]>([]);
  const [fotoUrl, setFotoUrl] = useState<any>(null);
  const [img, setImg] = useState<any>(null);
  const [removeAzure, setRemoveAzure] = useState(false);

  // Tab ENDEREÇO
  const [loadingMap, setLoadingMap] = useState(false);
  const [ampliar, setAmpliar] = useState(false);
  const [center, setCenter] = useState<any>({
    lat: -20.53690225701261,
    lng: -47.4013434553716,
  });
  const [map, setMap] = useState<google.maps.Map | null>(null);
  const [searchBox, setSearchBox] = useState<google.maps.places.SearchBox>();
  const [markers, setMarkers] = useState<any[]>([]);
  const [zoom, setZoom] = useState(13);
  const [mapHeight, setMapHeight] = useState('39.2vh');
  const [modalPerfilNumeroVisible, setModalPerfilNumeroVisible] = useState(
    false,
  );
  const [
    modalPerfilEndConfirmVisible,
    setModalPerfilEndConfirmVisible,
  ] = useState(false);
  const [placesAux, setPlacesAux] = useState<any>();

	const [libraries, setLibraries] = useState<any[]>([]);

  // Tab GESTÃO DE ACESSOS
  const [tabGestaoIndex, setTabGestaoIndex] = useState(0);
  const [acessos, setAcessos] = useState<AcessoData[]>([]);
  const [pesqAcessos, setPesqAcessos] = useState<any[]>([]);
  // const [roles, setRoles] = useState<RoleDATA[]>([]);
  const [modalPerfilAcessoVisible, setModalPerfilAcessoVisible] = useState(
    false,
  );
  const [acessoModal, setAcessoModal] = useState<AcessoData>({} as AcessoData);
  const [modalDeleteAcessoVisible, setModalDeleteAcessoVisible] = useState(
    false,
  );

	async function fetchPerfil() {
		try {
			const { data } = await api.get('portal/perfil/index');

			console.log('data ==> ', data);
			console.log('permissions ==> ', permissions);

			setLoja(data.loja);
			setCategorias(data.categorias);

			if (data.loja.endereco?.location) {
				setCenter(data.loja.endereco.location);
				setZoom(18);
			}
		}
		catch (error) {
			const isAppError = error instanceof AppError;
			const msg = isAppError ? error.message : 'Não foi possível buscar o perfil.';

			addToast({
				type: 'error',
				title: 'Buscar Perfil!',
				description: msg,
			});
		}
		finally {
			setLoading(false);

			const pedMin = formatPrice(formRef.current?.getFieldValue('ped_min'));
			formRef.current?.setFieldValue('ped_min', pedMin);

			setLoadingMap(true);
		}
	};

  // Tab LOJA
	async function handleMoeda(field: string) {
    let moedastr = formRef.current?.getFieldValue(`${field}`);
    moedastr = moedastr.replace(/\D/g, '');

    if (moedastr) {
      const moeda = parseInt(moedastr.replace(/[\D]+/g, ''));

      let tmp = `${moeda}`;
      tmp = tmp.replace(/([0-9]{2})$/g, ',$1');
      if (tmp.length > 6)
        tmp = tmp.replace(/([0-9]{3}),([0-9]{2}$)/g, '.$1,$2');

      formRef.current?.setFieldValue(`${field}`, `R$ ${tmp}`);
    } else {
      moedastr = moedastr.replace(/\D/g, '');
      formRef.current?.setFieldValue(`${field}`, `${moedastr}`);
    }
  };

  const resizeFile = useCallback((file: any) => {
    return new Promise(resolve => {
      Resizer.imageFileResizer(
        file,
        1920,
        1080,
        'JPEG',
        80,
        0,
        uri => {
          resolve(uri);
        },
        'file',
      );
    });
  }, []);

  const handleImagemChange = useCallback(
    async (event: ChangeEvent<HTMLInputElement>) => {
      if (event.target.files && event.target.files.length > 0) {
        const file = event.target.files[0];
        const size = parseFloat((file.size / 1024 / 1024).toFixed(1));

        // Se for maior que 4 megabytes
        if (size > 4) {
          alert('Tamanho da imagem superior ao permitido!');
          return;
        }

        if (loja.url_avatar) {
          setRemoveAzure(true);
        }

        if (size > 1) {
          const aux: any = await resizeFile(file);

          setImg(aux);
          setFotoUrl(URL.createObjectURL(aux));
        } else {
          setImg(file);
          setFotoUrl(URL.createObjectURL(file));
        }
      }

      event.target.value = '';
    },
    [loja, resizeFile],
  );

  const handleRemoveImg = useCallback(() => {
    setImg(null);
    setFotoUrl(null);
    setRemoveAzure(false);
  }, []);

	async function handleSubmitLoja(form: any) {
		try {
			formRef.current?.setErrors({});

			const schema = Yup.object().shape({
				nome: Yup.string().required('Nome da loja é obrigatório'),
				fone: Yup.string().required('Telefone é obrigatório'),
				categoria: Yup.number().required('Categoria é obrigatório'),
			});

			await schema.validate(form, {
				abortEarly: false,
			});

			setLoadingContent(true);

			loja.nome = form.nome;
			loja.fone = form.fone;
			loja.categoria = form.categoria;
			loja.descricao = form.descricao;

			const auxPed_min = parseFloat(
				form.ped_min.replace('R$', '').replace(' ', '').replace(',', '.'),
			);

			loja.ped_min = auxPed_min;

			const dataForm = new FormData();

			dataForm.append('avatar', img);
			dataForm.append('remove_azure', JSON.stringify(removeAzure));
			dataForm.append('loja', JSON.stringify(loja));

			const { data } = await api.post('portal/perfil/store_loja', dataForm, {
					headers: {
						type_picture: '-avatar',
					},
				});

			setLoja(data.loja);
			setImg(null);
			setFotoUrl(null);

			setLoadingContent(false);

			addToast({
				type: 'success',
				title: 'Cadastro de Loja',
				description: `Dados da Loja atualizados!`,
			});
		}
		catch (error) {
			if (error instanceof Yup.ValidationError) {
				const errors = getValidationErrors(error);
				formRef.current?.setErrors(errors);
				return;
			};

			const isAppError = error instanceof AppError;
			const msg = isAppError ? error.message : 'Não foi possível atualizar os dados da loja.';

			addToast({
				type: 'error',
				title: 'Cadastro de Loja',
				description: msg,
			});
		}
  };

  // Tab ENDEREÇO
  const onMapLoad = useCallback((mapa: google.maps.Map) => {
    setMap(mapa);
  }, []);
  const onMapUnmount = useCallback(() => {
    setMap(null);
  }, []);
  /* const onLoad = useCallback((ref: google.maps.places.SearchBox) => {
    setSearchBox(ref);
  }, []); */

	const onPlacesChanged = useCallback(() => {
    if (formMapRef.current?.getFieldValue('endereco') === '') {
      return;
    }

    //const places = searchBox!.getPlaces();
		const places = searchBoxRef.current?.getPlaces();
    setPlacesAux(places);

    if (!places![0].address_components) {
      return;
    }

    formMapRef.current?.reset();

    if (places![0].address_components.length < 7) {
      setModalPerfilNumeroVisible(true);
      return;
    }

    if (places) {
      const place = places[0];
      const location = {
        lat: place?.geometry?.location?.lat() || 0,
        lng: place?.geometry?.location?.lng() || 0,
      };

			const aux: any[] = [];
      aux.push(location);

      setMarkers(aux);
      map?.panTo(location);

      setCenter(location);
      setZoom(17);

			if (placesAux && placesAux![0].address_components)
      	formMapRef.current?.getFieldRef('comp')?.focus();
    }
  }, [map, searchBox]);
	const onDragEnd = useCallback((event: any) => {
      const places = placesAux;
      places![0].geometry.location = event.latLng;

      setPlacesAux(places);

      const markers_aux = [];
      markers_aux.push(event.latLng);

      setMarkers(markers_aux);
      map?.panTo(event.latLng);
      setCenter(event.latLng);
    },
    [placesAux, map],
  );
	const handlePlacesNum = useCallback((places: any, location: any) => {
		const location_aux = new google.maps.LatLng(location);
		places![0].geometry.location = location_aux;

		const markers_aux = [];
		markers_aux.push(location);

		setMarkers(markers_aux);
		map?.panTo(location);

		setCenter(location);
		setZoom(17);

		formMapRef.current?.reset();

		setPlacesAux(places);
	}, [map]);
	
	const handleSubmitEnd = useCallback(async () => {
		try {
			setLoadingContent(true);
			const lojaAux = loja;

			lojaAux.endereco = {
				cep: placesAux![0].address_components[6].short_name,
				uf: placesAux![0].address_components[4].short_name,
				cid: placesAux![0].address_components[3].short_name,
				cidcod: '',
				bai: placesAux![0].address_components[2].short_name,
				endereco: placesAux![0].address_components[1].short_name,
				num: placesAux![0].address_components[0].short_name,
				comp: formMapRef.current?.getFieldValue('comp'),
				formatted_address: placesAux![0].formatted_address,
				location: {
					lat: placesAux![0].geometry?.location?.lat(),
					lng: placesAux![0].geometry?.location?.lng(),
				},
			};

			const { data } = await api.post('portal/perfil/store_end', { loja: lojaAux });

			setLoja(data.loja);
			formMapRef.current?.reset();
			setPlacesAux(null);

			setTimeout(() => {
				setMapHeight('39.2vh');
				setCenter(data.loja.location);
				setZoom(18);
			}, 1000);
		}
		catch (error) {
			const isAppError = error instanceof AppError;
			const msg = isAppError ? error.message : 'Não foi cadastrar endereço da loja.';

			addToast({
				type: 'error',
				title: 'Cadastro de Endereço',
				description: msg,
			});
		}
		finally {
			setLoadingContent(false);

			addToast({
				type: 'success',
				title: 'Cadastro de Endereço',
				description: `Dados do endereço da Loja atualizados!`,
			});

			setAmpliar(false);
		}
  }, [placesAux, loja, addToast]);

  // Tab GESTÃO DE ACESSOS
	const handleAcessos = useCallback(async () => {
		try {
			setLoadingContent(true);

			const { data } = await api.get('portal/user/index');

			setAcessos(data.acessos);
			setPesqAcessos(data.acessos);
			// setRoles(response.data.roles);
		}
		catch (error) {
			const isAppError = error instanceof AppError;
			const msg = isAppError ? error.message : 'Não foi possível buscar os acessos.';

			addToast({
				type: 'error',
				title: 'Buscar Acessos!',
				description: msg,
			});
		}
		finally {
			setLoadingContent(false);
			setLoadingMap(true);
		}
	}, []);

  // quando trocar a empresa busca os acessos
	useEffect(() => {
		setLoading(true);
		setLibraries(['places']);
		fetchPerfil();
		handleAcessos();
	}, [company]);

  const handlePesquisaAcesso = useCallback(() => {
    const texto = formGestaoAcessoRef.current?.getFieldValue('search');

    if (texto === '' || texto === ' ') {
      setPesqAcessos(acessos);
      return;
    }

    const searchKeys = ['nome', 'email', 'role'];
    const results = search(acessos, searchKeys, texto);

    setPesqAcessos(results);
  }, [acessos]);

  return (
    <>
      <Container>
				<Sidebar />
				
        {loading ? (
          <Loading />
        ) : (
          <>
            {loadingContent && <Loading />}

            <Content>
              <TabsView>
                <Tabs className="tabs" index={tabIndex}>
                  <TabList className="tab-list">
                    <Tab className="tab" onClick={() => setTabIndex(0)}>
                      Loja
                    </Tab>
                    <Tab className="tab" onClick={() => setTabIndex(1)}>
                      Endereço
                    </Tab>
                    <Tab
                      className="tab"
                      onClick={() => {
                        setTabIndex(2);
                        handleAcessos();
                      }}
                    >
                      Gestão de Acessos
                    </Tab>
                  </TabList>

                  <TabPanels className="tab-panels">
                    <TabLoja className="tab-panel">
                      <ImgInput>
                        <img
                          src={
                            fotoUrl
                              ? fotoUrl
                              : loja.url_avatar !== ''
                              ? loja.url_avatar
                              : 'https://safetycloud.blob.core.windows.net/cashback-promocoes/placeholder-image.png'
                          }
                          alt=""
                        />

												{permissions.alterar && (
													<>
														<label className="select-picture" htmlFor="imagem">
                          <FiCamera />

                          <input
                            type="file"
                            id="imagem"
                            name="imagem"
                            onChange={handleImagemChange}
                          />
                        </label>

                        {
                          // img || product?.url_imagem ? (
                          fotoUrl ? (
                            <label
                              className="remove-picture"
                              onClick={handleRemoveImg}
                            >
                              <FiX />
                            </label>
                          ) : null
                        }
													</>
												)}
                        
                      </ImgInput>

                      <FormView
                        ref={formRef}
                        initialData={loja}
                        onSubmit={handleSubmitLoja}
                      >
                        <h1>{loja.nome}</h1>

                        <div className="input">
                          <p>Nome da Loja <span>(obrigatório)</span></p>
                          <Input
														name="nome"
														placeholder="nome"
														disabled={!permissions.alterar}
													/>
                        </div>

                        <div className="input">
                          <p>Telefone de contato <span>(obrigatório)</span></p>
                          <Input
                            name="fone"
                            placeholder="Telefone de contato"
														disabled={!permissions.alterar}
                          />
                        </div>

                        <div className="input">
                          <p>Categoria <span>(obrigatório)</span></p>
                          <InputSelect
                            options={categorias}
                            name="categoria"
                            placeholder="Categoria"
														disabled={!permissions.alterar}
                          />
                        </div>

                        <div className="input">
                          <p>Descrição</p>
                          <InputTextArea
                            name="descricao"
                            placeholder="Descrição"
														disabled={!permissions.alterar}
                          />
                        </div>

                        <div className="input">
                          <p>Pedido mínimo</p>
                          <Input
                            name="ped_min"
                            placeholder="Pedido mínimo"
                            onChange={() => handleMoeda('ped_min')}
														disabled={!permissions.alterar}
                          />
                        </div>

												{permissions.alterar && <button>Salvar</button>}
                      </FormView>
                    </TabLoja>

                    <TabEndereco className="tab-panel">
											<MapView ampliar={ampliar}>
												{loadingMap &&
													<LoadScript
														googleMapsApiKey='AIzaSyD76z5czkAXWvXjCdvl2YaL-4QX6b4jRs4'
														libraries={libraries}
													>
														<GoogleMap
															onLoad={onMapLoad}
															onUnmount={onMapUnmount}
															mapContainerStyle={{
																width: '100%',
																height: mapHeight,
																borderRadius: '8px',
															}}
															center={center}
															zoom={zoom}
															clickableIcons={true}
														>
															<StandaloneSearchBox
																// onLoad={onLoad}
																onLoad={ref => (searchBoxRef.current = ref)}
																onPlacesChanged={onPlacesChanged}
															>
																<div className="edit-endereco">
																	<h1>Alterar Endereço</h1>

																	<Form ref={formMapRef} onSubmit={() => { }}>
																		<Input
																			id="endereco"
																			name="endereco"
																			placeholder="Digite um Endereço"
																		/>

																		{placesAux &&
																			placesAux![0].address_components && (
																				<div className="new-end">
																					<EndEditMap places={placesAux} />

																					<div className="input">
																						<p>Complemento</p>

																						<Input
																							name="comp"
																							placeholder="Ex. 3 andar, bloco 1, etc..."
																							containerStyle={{
																								paddingTop: '5px',
																								paddingBottom: '5px',
																							}}
																						/>
																					</div>

																					<button
																						className="btn-confirm"
																						onClick={() => {
																							// handleSubmitEnd();
																							setModalPerfilEndConfirmVisible(true);
																						}}
																						disabled={
																							placesAux![0].address_components
																								?.length < 7
																						}
																					>
																						Confirmar
																					</button>
																				</div>
																			)}
																	</Form>

																	<button
																		onClick={() => {
																			setAmpliar(!ampliar);
																			setZoom(18);
																			setTimeout(() => {
																				setMapHeight('39.2vh');
																			}, 1000);
																			setCenter(loja.endereco?.location);
																			formMapRef.current?.reset();
																			setPlacesAux(null);
																		}}
																	>
																		Cancelar
																	</button>
																</div>
															</StandaloneSearchBox>

															{!ampliar && loja.endereco?.location && (
																<Marker position={center} />
															)}

															{markers.map((marker, indice) => (
																<Marker
																	key={indice}
																	position={marker}
																	draggable
																	onDragEnd={e => onDragEnd(e)}
																/>
															))}
														</GoogleMap>
													</LoadScript>
												}
											</MapView>

                      {!ampliar && (
                        <div className="endereco">
                          {loja.endereco ? (
                            <>
                              <h1>Endereço da loja</h1>
                              <h2>
                                {loja.endereco?.endereco}, {loja.endereco?.num}{' '}
                                {loja.endereco?.bai}
                              </h2>
                              {loja.endereco?.comp && (
                                <h2
                                  style={{ color: '#546E7A', paddingTop: '0' }}
                                >
                                  {loja.endereco?.comp}
                                </h2>
                              )}
                              <h2>CEP - {loja.endereco?.cep}</h2>
                              <h2>
                                {loja.endereco?.cid?.toUpperCase()},{' '}
                                {loja.endereco?.uf?.toUpperCase()}
                              </h2>
                            </>
                          ) : (
                            <h2>Loja sem endereço cadastrado.</h2>
                          )}

													{permissions.alterar && (
														<button
															onClick={() => {
																setAmpliar(!ampliar);
																setMapHeight('87.2vh');
																setZoom(13);
																setCenter({
																	lat: -20.536095333200908,
																	lng: -47.40091339554057,
																});
															}}
														>
															Editar Endereço
														</button>
													)}
                        </div>
                      )}
                    </TabEndereco>

                    <GestaoAcessos className="tab-panel">
                      <GestaoAcessosContent>
                        <h1>Gestão de Acessos</h1>

                        <h2>
                          Crie e edite diferentes permissões de acesso aos dados
                          da loja.
                        </h2>

                        <GestaoAcessoForm
                          ref={formGestaoAcessoRef}
                          onSubmit={() => {}}
                        >
                          <div className="gestao-div-input">
                            <Input
                              icon={FiSearch}
                              name="search"
                              placeholder="Buscar pelo nome da pessoa"
                              onChange={handlePesquisaAcesso}
                            />
                          </div>

													{permissions.incluir && (
														<div className="gestao-div-button">
															<button
																onClick={() => {
																	setAcessoModal({} as AcessoData);
																	setModalPerfilAcessoVisible(true);
																}}
															>
																Criar Acesso
															</button>
														</div>
													)}
                        </GestaoAcessoForm>

                        <Tabs className="tabs" index={tabGestaoIndex}>
                          <TabList className="tab-list">
                            <Tab className="tab"  onClick={() => setTabGestaoIndex(0)}>
                              Ativos
                            </Tab>
														
                            <Tab className="tab" onClick={() => setTabGestaoIndex(1)}>
                              Removidos
                            </Tab>
                          </TabList>

                          <TabPanels className="tab-panels">
														{/* PAINEL ATIVOS */}
                            <TabPanel className="tab-panel tab-panel-content">
                              <Table variant="simple" className="table">
                                <Thead className="head">
                                  <Tr>
                                    <Th>Usuário</Th>
                                    <Th>Email</Th>
                                    <Th>Permissões</Th>
																		{(permissions.alterar || permissions.excluir) && <Th isNumeric></Th>}
                                  </Tr>
                                </Thead>

                                <Tbody className="body">
                                  {pesqAcessos.map((acesso, indice) =>
																		acesso.status === 'S' && (
																			<Tr key={indice}>
																				<Td>{acesso.nome}</Td>
																				<Td>{acesso.email}</Td>
																				<Td>{acesso.role}</Td>
																				{(permissions.alterar || permissions.excluir) && (
																					<Td
																						isNumeric
																						className="td-buttons"
																					>
																						{permissions.alterar && (
																							<button
																								onClick={() => {
																									setAcessoModal(acesso);
																									setModalPerfilAcessoVisible(
																										true,
																									);
																								}}
																							>
																								<FaEdit />
																							</button>
																						)}

																						{permissions.excluir && (
																							<button
																								onClick={() => {
																									setAcessoModal(acesso);
																									setModalDeleteAcessoVisible(
																										true,
																									);
																								}}
																							>
																								<FiTrash2 />
																							</button>
																						)}
																					</Td>
																				)}
																			</Tr>
																		),
                                  )}
                                </Tbody>
                              </Table>
														
															<List className="cards" w="100%" spacing="10px">
																{pesqAcessos.map((acesso, indice) => {
																	return (
																		acesso.status === 'S' && (
																			<ListItem
																				key={indice}
																				flexDir="column"
																				boxShadow="md"
																				borderWidth={1}
																				borderColor="gray.50"
																				borderRadius={8}
																				p="10px"
																				w="100%"
																			>
																				<Text>{acesso.nome}</Text>
																				<Text>{acesso.email}</Text>

																				<Flex justifyContent="space-between">
																					<Text>{acesso.role}</Text>

																					<Flex>
																						<button
																							onClick={() => {
																								setAcessoModal(acesso);
																								setModalPerfilAcessoVisible(
																									true,
																								);
																							}}
																						>
																							<FaEdit />
																						</button>
																						<button
																							onClick={() => {
																								setAcessoModal(acesso);
																								setModalDeleteAcessoVisible(
																									true,
																								);
																							}}
																						>
																							<FiTrash2 />
																						</button>
																					</Flex>
																				</Flex>
																			</ListItem>
																		)
																	)
																})}
															</List>
                            </TabPanel>

														{/* PAINEL REMOVIDOS */}
                            <TabPanel className="tab-panel tab-panel-content">
                              <Table variant="simple" className="table">
                                <Thead className="head">
                                  <Tr>
                                    <Th>Usuário</Th>
                                    <Th>Email</Th>
                                    <Th>Permissões</Th>
																		{permissions.alterar && <Th></Th>}
                                  </Tr>
                                </Thead>

                                <Tbody className="body">
                                  {pesqAcessos.map((acesso, indice) =>
                                      acesso.status === 'N' && (
                                        <Tr key={indice}>
                                          <Td>{acesso.nome}</Td>
                                          <Td>{acesso.email}</Td>
                                          <Td>{acesso.role}</Td>
																					{permissions.alterar && (
																						<Td
																							
																							className="td-buttons"
																						>
																							<button
																								onClick={() => {
																									setAcessoModal(acesso);
																									setModalPerfilAcessoVisible(
																										true,
																									);
																								}}
																							>
																								<FaEdit />
																							</button>{' '}
																							<button
																								onClick={() => {
																									setAcessoModal(acesso);
																									setModalDeleteAcessoVisible(
																										true,
																									);
																								}}
																							>
																								<FiLogIn />
																							</button>
																						</Td>
																					)}
                                        </Tr>
                                      ),
                                  )}
                                </Tbody>
                              </Table>

															<List className="cards" w="100%" spacing="10px">
																{pesqAcessos.map((acesso, indice) => {
																	return (
																		acesso.status === 'N' && (
																			<ListItem
																				key={indice}
																				flexDir="column"
																				// boxShadow="xl"
																				borderWidth={1}
																				borderColor="gray.50"
																				borderRadius={8}
																				p="10px"
																				w="100%"
																			>
																				<Text>{acesso.nome}</Text>
																				<Text>{acesso.email}</Text>

																				<Flex justifyContent="space-between">
																					<Text>{acesso.role}</Text>

																					<Flex>
																						<button
																							onClick={() => {
																								setAcessoModal(acesso);
																								setModalPerfilAcessoVisible(
																									true,
																								);
																							}}
																						>
																							<FaEdit />
																						</button>
																						<button
																							onClick={() => {
																								setAcessoModal(acesso);
																								setModalDeleteAcessoVisible(
																									true,
																								);
																							}}
																						>
																							<FiLogIn />
																						</button>
																					</Flex>
																				</Flex>
																			</ListItem>
																		)
																	)
																})}
															</List>
                            </TabPanel>
                          </TabPanels>
                        </Tabs>
                      </GestaoAcessosContent>
                    </GestaoAcessos>
                  </TabPanels>
                </Tabs>
              </TabsView>
            </Content>
          </>
        )}
      </Container>

      {modalPerfilNumeroVisible && (
        <ModalPerfilNumero
          onClose={() => setModalPerfilNumeroVisible(false)}
          isVisible={modalPerfilNumeroVisible}
          places={placesAux}
          handlePlacesNum={handlePlacesNum}
        />
      )}

      {modalPerfilEndConfirmVisible && (
        <ModalPerfilEndConfirm
          onClose={() => setModalPerfilEndConfirmVisible(false)}
          isVisible={modalPerfilEndConfirmVisible}
          places={placesAux}
          comp={formMapRef.current?.getFieldValue('comp')}
          handleSubmitEnd={handleSubmitEnd}
        />
      )}

      {modalPerfilAcessoVisible && (
        <ModalPerfilAcesso
          onClose={() => setModalPerfilAcessoVisible(false)}
          isVisible={modalPerfilAcessoVisible}
          acesso={acessoModal}
          setAcessos={setAcessos}
          setPesqAcessos={setPesqAcessos}
          handleAcessos={handleAcessos}
        />
      )}

      {modalDeleteAcessoVisible && (
        <ModalPerfilDeleteAcesso
          onClose={() => setModalDeleteAcessoVisible(false)}
          isVisible={modalDeleteAcessoVisible}
          acesso={acessoModal}
          setAcessos={setAcessos}
          setPesqAcessos={setPesqAcessos}
        />
      )}
    </>
  );
};

export default Perfil;
